import { createStyles, Theme } from '@material-ui/core/styles';

import { colors } from '@shared/theme/colours';

export const styles = ({ spacing }: Theme) =>
  createStyles({
    root: {
      flexDirection: 'column',
      maxWidth: 300,
    },
    option: {
      borderRadius: 6,
    },
    optionAvatar: {
      marginRight: spacing(1.5),
    },
    userName: {
      fontSize: 14,
      marginRight: spacing(2),
    },
    label: {
      color: colors.grey.darker,
      fontSize: 14,
      marginBottom: spacing(3),
    },
    searchField: {
      flex: '1 1 auto',
    },
    optionLabel: {
      fontSize: 14,
    },
    searchFieldInput: {
      width: '100%',
    },
    inputWrap: {
      display: 'flex',
      alignItems: 'center',
      position: 'relative',
    },
    avatarPlaceholder: {
      borderRadius: '50%',
      backgroundColor: colors.grey.lightish,
      minWidth: 24,
      height: 24,
      marginRight: 6,
      marginLeft: -6,
    },
    avatar: {
      display: 'block',
      marginRight: 6,
      marginLeft: -6,
    },
    autocompleteList: {
      padding: 0,
    },
    autocompleteListItem: {
      padding: '6px 11px',

      '&:hover': {
        color: colors.black.darker,
        backgroundColor: colors.blue.lighter,
      },
    },
  });
